export const iconFontAwesomeArrowsAngleUp = (
	<i className="fa-solid fa-angle-up"></i>
);
